import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormCheck } from 'react-bootstrap';
import AreaN1DataService from "./services/arean1.service";
import OrganigramaDataService from "./services/organigrama.service";
import OrganigramaAreaDataService from './services/organigramaarea.service'
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
//import SublocationsList from './AreaN2List';
//import NewSublocation from './NewSublocation';
import { PageHeader } from './AuxiliaryFunctions';
import ExportSidebar from './ProSideBar';
import Sidebar from './Sidebar';
import CompetenciaAreasN1List from './CompetenciaAreasN1List';
import AgregarAreaN1 from './AgregarAreaN1';



var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditOrganigramaAreas = (props) => {
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [listOfAreasN1, setlistOflistOfAreasN1] = useState([]);
  const [organigrama, setOrganigrama] = useState(null);
  const [pagetitle, setpagetitle] = useState(null);

  useEffect(() => {    
    retrieveOrganigrama();
    retrieveOrganigramaAreasN1();  
  }, []);

  useEffect(() => {
    if (organigrama) {
      console.log(organigrama);
      setpagetitle("Editar organigrama " + organigrama.nombreorganigrama);
    }
    else {
      setpagetitle("No existe el organigrama con id=" + params.id);      
    }
  }, [organigrama]);

  const retrieveOrganigrama = () => {
    OrganigramaDataService.get(params.id)
      .then(response => {
        setOrganigrama(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }  

  const retrieveOrganigramaAreasN1 = () => {
    OrganigramaAreaDataService.getOrganigramaArea({parentid:params.id, childid:0, childcategory:'arean1'},"id","ASC")
      .then(response => {
        setlistOflistOfAreasN1(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
        setShowsuccess(false);
        setSuccmessage('');
        setShowerror(true);
        setErrmessage(e.response?e.response.data.message:e.message);
      });
  }
  
  return (
    <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />            
        <Container>
          <Row className='mb-4'>
            <PageHeader />
            <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>{pagetitle}</h5>      
          
            {showerror && (
              <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                <Alert.Heading>Error</Alert.Heading>
                <p>{errmessage}</p>
              </Alert>      
            )}
            {showsuccess && (
              <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                <Alert.Heading>Done</Alert.Heading>
                <p>{succmessage}</p>
            </Alert>      
            )}   
          </Row>

          <Row className='mb-4'>
            <Col className='col-md-3' md={4}>
              <FormLabel className='mb-2'>Nombre organigrama:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="nombreorganigrama" id="nombreorganigrama" disabled defaultValue={organigrama?organigrama.nombreorganigrama:null}></FormControl>
            </Col>                
            <Col md={10}>
              <FormLabel className='mb-2'>Descripción organigrama:</FormLabel>       
              <FormControl type="text" name="descripcionorganigrama" id="descripcionorganigrama" disabled defaultValue={organigrama?organigrama.descripcionorganigrama:null}></FormControl>
            </Col>   

            <Col className='col-md-3' md={4}>
              {/*<Button variant='secondary'> Agregar área N1</Button>*/}
              <AgregarAreaN1 organigrama={organigrama}/> 
            </Col>
            
          </Row>
        
          <Row className='mb-4'>
              <Alert>{"Areas N1 habilitadas para este organigrama. Utilice el botón Config para agregar áreas N2. Utilice el botón (+) para agregar más áreas N1."}</Alert>
              <CompetenciaAreasN1List 
                mode={0} 
                listOfAreasN1={listOfAreasN1} 
                organigrama={organigrama}
                //nombreorganigrama={organigrama.nombreorganigrama} 
                //organigramaid={organigrama.id}
              >
              </CompetenciaAreasN1List>            
          </Row>                                     
        </Container>    
      </div>
    </>
  )

}

export default EditOrganigramaAreas;

